import { ReactElement } from 'react';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../../translations';
import { ConsentsAndAuthorizationsDocumentsModalOpener } from '../../ConsentsAndAuthorizationsDocumentModal/ConsentsAndAuthorizationsDocumentsModal.opener';
import { AddConsentOrAuthorizationLink } from '../AddConsentOrAuthorizationLink';

import { StyledEmptyStatePlaceholder } from './ConsentsAndAuthorizationsTableEmptyStatePlaceholder.styled';

const t =
   patientConsentsAndAuthorizationsTranslationKeys.consentsAndAuthorizations.table
      .noConsentsAndAuthorizationsPlaceholder;

type ConsentsAndAuthorizationsTableEmptyStatePlaceholderProps = {
   readonly patientId: number;
};

export const ConsentsAndAuthorizationsTableEmptyStatePlaceholder = (
   props: ConsentsAndAuthorizationsTableEmptyStatePlaceholderProps
): ReactElement => {
   return (
      <StyledEmptyStatePlaceholder
         heading={t.header}
         subheading={t.subheader}
         fullLength
         testId={'noConsentsAndAuthorizations'}
         bottomElement={
            <ConsentsAndAuthorizationsDocumentsModalOpener patientId={props.patientId}>
               {({ openModal }) => <AddConsentOrAuthorizationLink onClick={openModal} />}
            </ConsentsAndAuthorizationsDocumentsModalOpener>
         }
      />
   );
};
